"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rateTypeConfigMap = exports.tariffNameToRateTypeMap = exports.rateTypeToModifierMap = void 0;
const business_1 = require("./TariffConfig/business");
const economy_1 = require("./TariffConfig/economy");
const economy_plus_1 = require("./TariffConfig/economy-plus");
exports.rateTypeToModifierMap = {
    'economy': 'green',
    'economy-plus': 'blue',
    'business': 'blue',
};
exports.tariffNameToRateTypeMap = {
    Economy: 'economy',
    Business: 'business',
};
/**
 * Here is config for the tariff in a design view.
 *
 * RateTariffType - is the name of the tariff used as a sign
 * TariffConfigType - is a static information for some tariff and can hold only state of a corresponding DB tariff.
 *
 * For newly created tariff we need to create new file.
 */
exports.rateTypeConfigMap = {
    // 'new-index-name': tariffNewIndexName
    'economy': economy_1.tariff,
    'economy-plus': economy_plus_1.tariff,
    'business': business_1.tariff,
};
//# sourceMappingURL=rateTypeMapper.js.map